export enum SafeTypes {
  html = 'html',
  style = 'style',
  script = 'script',
  url = 'url',
  resourceUrl = 'resourceUrl',
}
